import styles from './Button.module.scss'

function scrollToCenterOfSection(id) {
	const section = document.getElementById(id)
	if (section) {
		const rect = section.getBoundingClientRect()
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop
		const offsetTop = rect.top + scrollTop
		const centerOffset = window.innerHeight / 2 - rect.height / 2
		window.scrollTo({
			top: offsetTop - centerOffset,
			behavior: 'smooth',
		})
	}
}

export default function Button() {
	return (
		<button
			onClick={() => scrollToCenterOfSection('form-section')}
			className={styles.progiumButton}
		>
			Записаться
			<img src='./img/all/arrow.svg' alt='' />
		</button>
	)
}
